import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { swarnAppMainUrl, swarnAppLoginLogoPath, swarnAppLoginRightLogoPath, swarnAppHeaderLogoPath, jewelstepsLoginLogoPath, jewelstepsLoginRightLogoPath, jewelstepsHeaderLogoPath } from '../utils/comon-utils';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
    public onDeleteRowClicked =  new Subject<any>();
    public onEditIconRowClick =  new Subject<any>();
    public isInboxTabActive : boolean = false;

    private storage: any;
 
    //#region  dynamic set svg path variable
        logoLogin  :string;
        logoHeader :string;
        logoLoginRight :string;
        displayDefaultCompanyIcon
    //#endregion
    constructor() {
        this.storage = sessionStorage; // localStorage;

        const{host , origin}= window.location;
        if(origin == swarnAppMainUrl){
            document.documentElement.style.setProperty('--providedCompanyName', "'SwarnApp CRM'");
            this.logoLogin  = swarnAppLoginLogoPath;
            this.logoLoginRight = swarnAppLoginRightLogoPath;
            this.logoHeader =  swarnAppHeaderLogoPath;
        } else {
            document.documentElement.style.setProperty('--providedCompanyName', "'Jewelsteps CRM'");
            this.logoLogin = jewelstepsLoginLogoPath;
            this.logoLoginRight = jewelstepsLoginRightLogoPath;
            this.logoHeader = jewelstepsHeaderLogoPath; 
        }
    }

    public retrieve(key: string): any {
        let item = this.storage.getItem(key);

        if (item && item !== 'undefined') {
            return JSON.parse(this.storage.getItem(key));
        }

        return;
    }

    public removeItem(key: string) {
        this.storage.removeItem(key);
    }

    public store(key: string, value: any) {
        this.storage.setItem(key, JSON.stringify(value));
    }

    public clear() {
        this.storage.clear();   
    }
}
